export const NAME = 'largeFormatMachines';